import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageUrlCache'
})
export class ImageUrlCachePipe implements PipeTransform {
  private cache = new Map<string, Promise<string>>();

  transform(url: string): Promise<string> {
    if (!this.cache.has(url)) {
      const processedUrl = this.processImageUrl(url);
      this.cache.set(url, processedUrl);
    }
    return this.cache.get(url)!;
  }

  private async processImageUrl(url: string): Promise<string> {
    return url;
  }
}
